<div class="flex justify-end items-end flex-wrap gap-2 mb-4">
  <!-- <nz-page-header nzTitle="Environment Management"> Environment Management</nz-page-header> -->
  <button nz-button nzType="primary" type="button" (click)="openFormModal()"><i nz-icon nzType="plus"></i>
    Add
    Environment </button>
</div>

<nz-table #filterTable nzShowSizeChanger [nzData]="environments" nzTableLayout="fixed" [nzLoading]="isLoading"
  [nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'" [nzShowTotal]="totalTemplate"
  [nzData]="environments">
  <thead>
    <tr>
      @for (column of listOfColumns; track column) {
      <th>
        {{ column.name }}
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (data of filterTable.data; track data.id) {
    <tr>
      <td>{{ data.id }}</td>
      <td>{{ data.environment }}</td>
      <td nzEllipsis="...">
        <span nz-tooltip="Edit" [nzTooltipColor]="'#fff'" nz-icon nzType="edit" nzTheme="outline"
          class="text-base text-primary cursor-pointer" (click)="openEditModal(data)"></span>
        <span nz-tooltip="Delete" [nzTooltipColor]="'#fff'" nz-icon nzType="delete" nzTheme="outline"
          class="text-base text-danger cursor-pointer ml-5" nz-popconfirm nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?" (nzOnConfirm)="deleteEnv(data.id)"></span>
      </td>
    </tr>
    }
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isFormModalVisible" [nzTitle]="isEditMode ? 'Edit Environment' : 'Add Environment'"
  (nzOnCancel)="isFormModalVisible=false" [nzFooter]="modalFooter" nzWidth="500px">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="envForm" (ngSubmit)="submitForm()">
      <!-- Environment Name Field -->
      <nz-form-item class="mb-4">
        <nz-form-label [nzSpan]="24" nzFor="environmentName" nzRequired>
          <span class="inline-block">Environment Name</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24" nzErrorTip="Please enter an environment">
          <ng-container *ngIf="isEditMode; else selectMode">
            <input nz-input id="environmentName" formControlName="environment" placeholder="Enter Environment Name" />
          </ng-container>
          <ng-template #selectMode>
            <nz-select id="environmentName" formControlName="environment" nzPlaceHolder="Select Environment"
              nzShowSearch nzShowArrow="false">
              <nz-option *ngFor="let env of envOptions" [nzLabel]="env.environment"
                [nzValue]="env.environment"></nz-option>
            </nz-select>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <div class="flex justify-end gap-2">
      <button nz-button nzType="default" (click)="isFormModalVisible=false">Cancel</button>
      <button nz-button nzType="primary" [nzLoading]="isLoading" (click)="submitForm()">
        Save
      </button>
    </div>
  </ng-template>
</nz-modal>
<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>